import * as React from "react";
import { IconList as IconList$1 } from "@grandvisionhq/content";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { getUrl } from "../../../../utils/utils/get-url.js";
const CmsIconList = ({ page, content, theme }) => {
  const { iconLinkCompoundList = [], title } = content;
  const items = React.useMemo(() => {
    return iconLinkCompoundList.map(({ icon, link }) => ({
      icon,
      url: getUrl(link.url || "", page),
      label: link.label
    }));
  }, [iconLinkCompoundList, page]);
  return /* @__PURE__ */ React.createElement(IconList$1, { items, title, theme });
};
const IconList = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withEditableContent,
  withAnchor
)(CmsIconList);
export {
  CmsIconList,
  IconList as default
};
//# sourceMappingURL=IconList.js.map
